/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface AgencyModel {

        "cnpj"?: number;

        "companyData"?: CompanyModel;

        "address"?: AddressModel;

        "bankData"?: BankDataModel;

        "partners"?: Array<PartnerModel>;

        "user"?: string;

        "userIp"?: string;
    }

}
